import { render, staticRenderFns } from "./BankKeep.vue?vue&type=template&id=386f3738&scoped=true&"
import script from "./BankKeep.vue?vue&type=script&lang=js&"
export * from "./BankKeep.vue?vue&type=script&lang=js&"
import style0 from "./BankKeep.vue?vue&type=style&index=0&id=386f3738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f3738",
  null
  
)

export default component.exports